import React, { useEffect, useState } from "react";
import "./Getpost.css";
import axios from "axios";

function Getpost() {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios
      .get("https://jsonplaceholder.typicode.com/posts")
      .then((response) => setData(response.data))
      .catch((error) => console.error(error));
  }, []);

  return (
    <div className="post">
      {data.map((obj) => (
        <div key={obj.id} className="Post">
          <h2>{obj.title}</h2>
          <p>{obj.body}</p>
          <button>Read More</button>
        </div>
      ))}
    </div>
  );
}

export default Getpost;
